module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Retirement Age Calculator",
      "icon": "retirement-calculator"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    attrs: {
      "required": "",
      "name": "gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('gender')
    }
  }, [_vm._v("\n                    The gender is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                    The date of birth is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age",
      "label": "Retirement Age"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementAge),
      expression: "retirementAge"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "retirement_age",
      "type": "number",
      "name": "retirement_age"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_date",
      "label": "Retirement Date"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementDate),
      expression: "retirementDate"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "retirement_date",
      "type": "text",
      "name": "retirement_date"
    },
    domProps: {
      "value": (_vm.retirementDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementDate = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                This calculator works out when people will reach their State Pension age, under current legislation,\n                based on their gender and date of birth. The Pensions Act 2014 provides for a regular review of the\n                State Pension age, at least once every five years.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                For a " + _vm._s(_vm.gender) + " born on " + _vm._s(_vm.dateOfBirth) + ", the retirement age is "), _c('strong', [_vm._v(_vm._s(_vm.retirementAge))]), _vm._v(" which is reached on "), _c('strong', [_vm._v(_vm._s(_vm.retirementDate))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b9700174!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/retirementAge.vue
// module id = 1797
// module chunks = 0